import { BaseWebComponentDataProvider } from '../../../../framework/BaseWebComponentDataProvider';
import { Column, ColumnKeys, AssetType, EASMScanConfigurationAssetGridViewData } from '../types';
import { ViewType } from '../../../../grid/gridView/types';
import { ColumnDetails, ColumnType } from '../../../../grid/types/common';
import { translateFn } from '../../../../utils/translator.helper';
import { getAssetTypeValues } from '../types';
import { TimeRangeKind } from '@nirvana/shared/dtos/types/shared/time';
import { RELATIVE_TIME_RANGES } from '@nirvana/shared/constants';

export class EasmScanConfigurationAssetGridBaseDataProvider extends BaseWebComponentDataProvider {
  private gridColumns: Array<ColumnDetails<Column, ColumnKeys>> = [
    {
      column: Column.VALUE,
      key: ColumnKeys.VALUE,
      columnName: translateFn('Asset name'),
      type: ColumnType.STRING,
      removable: false,
      filterResetValue: { contains: '' },
    },
    {
      column: Column.TYPE,
      key: ColumnKeys.TYPE,
      columnName: translateFn('Asset type'),
      type: ColumnType.ENUM,
      values: getAssetTypeValues(),
      removable: false,
      filterResetValue: {
        in: [AssetType.IPv4, AssetType.IPv6, AssetType.EMAIL, AssetType.DOMAIN],
      },
    },
    {
      column: Column.DATE_ADDED,
      key: ColumnKeys.DATE_ADDED,
      columnName: translateFn('Date added'),
      type: ColumnType.DATE,
      removable: false,
      filterResetValue: {
        timeRange: {
          kind: TimeRangeKind.ALL_TO_DATE,
        },
      },
    },
    {
      column: Column.ACTIONS,
      key: ColumnKeys.ACTIONS,
      columnName: '',
      type: ColumnType.ACTION,
      removable: false,
      editingDisabled: true,
      filteringDisabled: true,
    },
  ];

  private FILTERS = [
    { value: { contains: '' } },
    {
      type: {
        in: [AssetType.IPv4, AssetType.IPv6, AssetType.EMAIL, AssetType.DOMAIN],
      },
    },
    {
      dateAdded: {
        timeRange: {
          kind: TimeRangeKind.ALL_TO_DATE,
        },
      },
    },
  ];

  public async getDataForView(): Promise<EASMScanConfigurationAssetGridViewData> {
    const view = {
      id: 'scan-configuration-item-grid',
      name: translateFn('Default view'),
      type: ViewType.DEFAULT,
      filters: this.FILTERS,
      displayedColumns: [0, 1, 2, 3],
      pageSize: 20,
      pageNumber: 1,
      compactView: false,
    };

    return {
      views: [view],
      allColumns: this.gridColumns,
      defaultViewProps: view,
    };
  }
}
